import type { Ref } from 'vue'

export default function useNavigationTrap(hasUnsavedChanges: Ref<boolean>) {
  const widgetStore = useWidgetStore()
  const navigationTrap = reactive<{ isResolving: boolean; resolveNavigation: (shouldStay: boolean) => void }>({
    isResolving: false,
    resolveNavigation: (_: boolean) => {},
  })

  const springTrap = async (escape: () => void) => {
    navigationTrap.isResolving = true

    widgetStore.setDialog('DialogLeavePage', {}, async ({ type }) => {
      if (type === 'stay') {
        navigationTrap.resolveNavigation(true)
      } else if (type === 'leave') {
        navigationTrap.resolveNavigation(false)
      }
    })
    const shouldStay = await new Promise<boolean>(resolve => {
      navigationTrap.resolveNavigation = resolve
    })

    if (shouldStay) {
      navigationTrap.isResolving = false
    } else {
      escape()
    }
  }

  onBeforeRouteLeave(async (to, _, next) => {
    if (!hasUnsavedChanges.value || ['sorry', '404'].includes(to.name ?? '')) {
      next()
      return
    }

    await springTrap(() => next())
  })

  return {
    springTrap,
  }
}
